// import React from 'react';
// import ReusableTabs from '../../../pages/ReusableTabs';
// import UploadSection from './Sections/UploadSection';
// import LibrarySection from './Sections/LibrarySection';
// import AuditSection from './Sections/AuditSection';

// const ReceivingPanel = () => {
//   const tabs = [
//     { label: 'UPLOAD', component: <UploadSection /> },
//     { label: 'LIBRARY', component: <LibrarySection /> },
//     { label: 'AUDITS', component: <AuditSection /> },
//   ];

//   return (
//     <div>
//       <ReusableTabs
//         tabs={tabs}
//         defaultTab={0}
//         panelStyles={{ padding: '16px' }}
//       />
//     </div>
//   );
// };

// export default ReceivingPanel;

import React, { useState, useEffect } from 'react';
import ReusableTabs from '../../../pages/ReusableTabs';
import UploadSection from './Sections/UploadSection';
import LibrarySection from './Sections/LibrarySection';
import AuditSection from './Sections/AuditSection';

const ReceivingPanel = () => {
  const [canEditReceiving, setCanEditReceiving] = useState(false);

  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanEditReceiving(roles.includes("SD_Receiving_Edit"));
    }
  }, []);

  const tabs = [
    ...(canEditReceiving
      ? [{ label: 'UPLOAD', component: <UploadSection /> }]
      : []
    ),
    { label: 'LIBRARY', component: <LibrarySection /> },
    { label: 'AUDITS', component: <AuditSection /> },
  ];

  return (
    <div>
      <ReusableTabs
        tabs={tabs}
        defaultTab={0}
        panelStyles={{ padding: '16px' }}
      />
    </div>
  );
};

export default ReceivingPanel;